import { Col, Container, Row } from "react-bootstrap";
import NavBar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./TechnologyInnovation.css";
// import techImg from "../../assets/img/tech.jpg";
import techImg from "../../assets/img/No_Image_Available.jpg";
import { Helmet } from "react-helmet";
import arbased from "../../assets/img/New-Pages/Technology-Innovation/AR-Based-Training.jpg";
import artificial from "../../assets/img/New-Pages/Technology-Innovation/Artificial-Intelligence.jpg";

// import un from "../../assets/awards/un.jpeg";
import assistive from "../../assets/img/New-Pages/Technology-Innovation-(icon)/Assistive.png";
import ar from "../../assets/img/New-Pages/Technology-Innovation-(icon)/AR-VR.png";
import universal from "../../assets/img/New-Pages/Technology-Innovation-(icon)/Universal.png";
import lms from "../../assets/img/New-Pages/Technology-Innovation-(icon)/LMS.png";




export default function TechnologyInnovation() {
  return (
    <>
      <Helmet>
        <title>
          Technology & Innovation | Manzil Center -Special Families Support
        </title>
        <meta
          name="description"
          content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
        />
        <meta name="keywords" content="Manzil center, Special Family Support, Technology and Innovation, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah" />
        <link
          rel="canonical"
          href="https://www.manzil.ae/technology-innovation"
        />
        <meta
          property="og:title"
          content="Technology & Innovation | Manzil Center -Special Families Support"
        />
        <meta
          property="og:description"
          content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
        />
        <meta
          property="og:url"
          content="https://www.manzil.ae/technology-innovation"
        />
        <meta
          property="og:image"
          content="https://www.manzil.ae/static/media/tech.c36c4b39166f77bc379f.jpg"
        />
        <meta
          name="twitter:title"
          content="Technology & Innovation | Manzil Center -Special Families Support"
        />
        <meta
          name="twitter:description"
          content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
        />
        <meta
          name="twitter:image"
          content="https://www.manzil.ae/static/media/tech.c36c4b39166f77bc379f.jpg"
        />
      </Helmet>
      <NavBar />
      <div className="page-title-area tech-inner">
        <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
          <div className="page-title-content">
            <ul>
              {/* <li>
                <a href="/">Home</a>
              </li> */}
              <li>
                <h1>Technology & Innovation</h1>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <Container className="my-4 pt-5">
        <Row>
          <Col lg={5}>
            <div class="tp-about-us__main-thumb">
              <img
                className="img-fluid"
                src="https://wphix.com/wp/poorex/wp-content/uploads/2023/07/about-us-1-1.jpg"
                alt=""
              />
              <div class="tp-about-us__thumb-sm">
                <img
                  className="img-fluid"
                  src="https://wphix.com/wp/poorex/wp-content/uploads/2023/07/about-us-1-2.jpg"
                  alt=""
                />
              </div>
              <div class="tp-about-us__thumb-border"></div>
            </div>
          </Col>
          <Col lg={7} className="ps-lg-5">
            <div className="ps-lg-5">
              <div className="main-heading">
                <h2 className="mb-4 m-0">Technology and Innovation</h2>
              </div>
              <p>
                Manzil has always been at the forefront of innovation and
                adopting best practices to impart knowledge.
              </p>
              <p>
                Working closely with a leading UAE AR/VR startup, we have
                created the region’s first immersive training experience for the
                hospitality sector. This will be accompanied by a research paper
                delving deeper into what works - and what doesn’t- especially
                for PwDs.
              </p>
              <p>
                We are also working on a medium term programme using NLP and
                machine learning to assess individuals, create training
                programmes and then match them to existing job opportunities.
                This could become a game changer in the way people are connected
                with the right opportunity!
              </p>
              <p>
                Lastly, we have also launched our online Learning Management
                System which has training content from Basic to Advanced levels
                covering a wide range of non academic subjects.
              </p>
            </div>
          </Col>
        </Row>
      </Container> */}

      <Container className="my-4 pb-lg-1">
        <Row>
          <Col lg={12}>
            <div className="main-heading text-center mb-5">
              {/* <span className="center">Technology Driving Services</span> */}
              {/* <p>
                Manzil has always been at the forefront of innovation and
                adopting best practices to acquire and impart knowledge. Here
                are some of the things we are doing (and working on to launch
                soon!) especially when it comes to the use of technology.
              </p> */}
              <p>At Manzil, we leverage assistive technology to create inclusive, accessible, and empowering environments for individuals with diverse needs. Whether it's through specialized devices, software, or adaptive tools, we ensure that every individual has the support they need to thrive in education, the workplace, and daily life.</p>
            </div>
          </Col>
          <Col lg={12} className="text-center mb-lg-4">
            <div className="main-heading">
              <span className="center">Enhancing Inclusion, Empowering Independence</span>
              <p className="mb-0">
                At Manzil, we are a center for inclusion, learning, and vocational empowerment. We strategically leverage assistive and inclusive tools to break down barriers, personalize support, and expand opportunities for individuals of determination.
              </p>
              <p>From classrooms to workplaces, we use technology not as a solution in itself, but as an enabler that supports human potential.</p>
            </div>
          </Col>
          {/* <Col lg={6}>
            <img src={techImg} className="img-fluid" alt="Immersive Technology , AI based Assessments & Training , LMS | Manzil" />
          </Col> */}
          <Col lg={12} className="mb-5">
            <Row>
              {/* <Col md={6} className="mb-4">
                <div className="oracle-partner-card">
                  <h3> Technology driving Services</h3>
                  <p>
                    Manzil has always been at the forefront of innovation and
                    adopting best practices to acquire and impart knowledge.
                    Here are some of the things we are doing (and working on to
                    launch soon!) especially when it comes to the use of
                    technology.
                  </p>
                </div>
              </Col> */}
              {/* <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <h3>Immersive Technology</h3>
                  <p>
                    Working closely with a leading UAE AR/VR startup, we have
                    created the region’s first immersive training experience for
                    the hospitality sector. This will be accompanied by a
                    research paper delving deeper into what works and what
                    doesn’t for PwDs.
                  </p>
                </div>
              </Col>
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <h3> AI based Assessments & Training</h3>
                  <p>
                    We are also working on a medium term programme using NLP and
                    machine learning to assess individuals, create training
                    programmes and then match them to existing job
                    opportunities. This could become a game changer in the way
                    people are connected with the right opportunity!
                  </p>
                </div>
              </Col>
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <h3>LMS</h3>
                  <p>
                    We have launched our online Learning Management System which
                    has training content from Basic to Advanced levels covering
                    a wide range of non academic subjects.
                  </p>
                </div>
              </Col> */}
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <img
                    src={assistive}
                    className="img-fluid mb-3"
                    alt="United Nations Zero Project Award"
                  />

                  <h3>Assistive Technology Integration</h3>
                  <p className="mb-0">
                    Our programs incorporate a wide range of assistive tools that empower learners with physical, sensory, or cognitive challenges to participate more fully. These may include:
                  </p>
                  <ul>
                    <li>
                      Text-to-speech and speech-to-text software
                    </li>
                    <li>Visual supports and sensory aids</li>
                  </ul>
                </div>
              </Col>
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <img
                    src={ar}
                    className="img-fluid mb-3"
                    alt="United Nations Zero Project Award"
                  />

                  <h3> AR/VR & Simulation-Based Training</h3>
                  <p className="mb-0">
                    To bridge the gap between learning and real-life application, we use augmented reality (AR) and virtual reality (VR) simulations that recreate real-world environments such as workplaces, public transit systems, and daily living spaces in a safe, controlled, and adaptive way.                  </p>
                  <ul>
                    <li>
                      Provide experiential learning without real-world risks                    </li>
                    <li>Support pre-employment training, independent living, and community navigation</li>
                  </ul>
                </div>
              </Col>
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <img
                    src={universal}
                    className="img-fluid mb-3"
                    alt="United Nations Zero Project Award"
                  />

                  <h3>Universal Design for Learning (UDL) in Action</h3>
                  <p className="mb-0">
                    We adopt Universal Design for Learning principles across all educational and training settings, supported by tech that enables multiple means of:   </p>
                  <ul>
                    <li>
                      Representation (visual, auditory, interactive) </li>
                    <li>Expression (written, verbal, non-verbal)</li>
                  </ul>
                </div>
              </Col>
              <Col md={12} className="mb-4">
                <div className="oracle-partner-card">
                  <img
                    src={lms}
                    className="img-fluid mb-3"
                    alt="United Nations Zero Project Award"
                  />

                  <h3>Learning Management System (LMS)</h3>
                  <p className="mb-0">
                    Our custom LMS makes learning and progress tracking easy for everyone—from teachers and therapists to parents and students. Built with accessibility in mind, it includes: </p>
                  <ul>
                    <li>
                      Easy-to-navigate dashboards </li>
                    <li>Audio-visual supports and multilingual options</li>
                  </ul>
                </div>
              </Col>




            </Row>
          </Col>

          {/* new section */}
          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={arbased}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="service-content">
                <h5 className="mb-2">
                  <span>AR Based Training</span>
                </h5>
                <p className="mb-2">Empowering learners under 16 with inclusive, creative, and personalised growth journeys.</p>
                <a href="/ar-based-training" class="default-btn default-btn-orange me-0 nav-link">Read More</a>

              </div>
            </div>

          </div>

          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={artificial}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="service-content">
                <h5 className="mb-2">
                  <span>Artificial Intelligence</span>
                </h5>
                <p className="mb-2">Empowering learners under 16 with inclusive, creative, and personalised growth journeys.</p>
                <a href="/artificial-intelligence" class="default-btn default-btn-orange me-0 nav-link">Read More</a>

              </div>
            </div>

          </div>


        </Row>
      </Container>
      <Footer />
    </>
  );
}
